import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { endpoints } from "../../../services/apiurl";
import Input from "../../UI/Input/Input";
import Card from "@mui/material/Card";

const PopupDetail = () => {
  let history = useHistory();
  let { id } = useParams();

  const [cat, setCat] = useState({
    session: "",
    rest: "",
    restaurent: [],
  });

  const [name, setName] = useState(null);
  const [email, setEmail] = useState(0);
  const [mobile, setMobile] = useState(0);
  const [birthday, setBirthday] = useState(0);
  const [gender, setgender] = useState(0);
  const [cross_btn, setCrossBtn] = useState(0);
  const [table_no, setTableNo] = useState(0);
  const [status, setPopupStatus] = useState(0);

  const [name_dis, setNameDisplay] = useState(null);
  const [email_dis, setEmailDisplay] = useState(0);
  const [mobile_dis, setMobileDisplay] = useState(0);
  const [birthday_dis, setBirthdayDisplay] = useState(0);
  const [gender_dis, setgenderDisplay] = useState(0);
  const [cross_btn_dis, setCrossBtnDisplay] = useState(0);
  const [table_no_dis, setTableNoDisplay] = useState(0);
  const [status_dis, setPopupStatusDisplay] = useState(0);

  const [loading, setloading] = useState(false);

  const { session, rest } = cat;
  // const links = restaurent;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    //   console.log(cat);
  };

  useEffect(() => {
    edit();
  }, []);
  //console.log(id)

  const edit = async () => {
    await axios
      .post(endpoints.popup_detail, { restro_id: id })
      .then((response) => {
        //  console.log(JSON.parse(response.data.data[0].name)['display'])
        setCat({
          id: response.data.data[0].id,
          session: response.data.data[0].session,
          rest: response.data.data[0].rest,
        });
        // console.log(response.data.data[0].rest)

        setName(JSON.parse(response.data.data[0].name)["mandatory"]);
        setEmail(JSON.parse(response.data.data[0].email)["mandatory"]);
        setMobile(JSON.parse(response.data.data[0].mobile)["mandatory"]);
        setBirthday(JSON.parse(response.data.data[0].birthday)["mandatory"]);
        setgender(JSON.parse(response.data.data[0].gender)["mandatory"]);
        setTableNo(JSON.parse(response.data.data[0].table_no)["mandatory"]);
        setCrossBtn(JSON.parse(response.data.data[0].cross_btn)["mandatory"]);

        setNameDisplay(JSON.parse(response.data.data[0].name)["display"]);
        setEmailDisplay(JSON.parse(response.data.data[0].email)["display"]);
        setMobileDisplay(JSON.parse(response.data.data[0].mobile)["display"]);
        setBirthdayDisplay(
          JSON.parse(response.data.data[0].birthday)["display"]
        );
        setgenderDisplay(JSON.parse(response.data.data[0].gender)["display"]);
        setTableNoDisplay(
          JSON.parse(response.data.data[0].table_no)["display"]
        );
        setCrossBtnDisplay(
          JSON.parse(response.data.data[0].cross_btn)["display"]
        );
        setPopupStatusDisplay(response.data.data[0].status);
      });
  };
  // console.log(cat.rest)
  const setname = async (e, type) => {
    if (e.target.checked) {
      setName(1);
    } else {
      setName(0);
    }
  };

  const setname_dis = async (e, type) => {
    if (e.target.checked) {
      setNameDisplay(1);
    } else {
      setNameDisplay(0);
    }
  };

  const setemail = async (e, type) => {
    if (e.target.checked) {
      setEmail(1);
    } else {
      setEmail(0);
    }
  };

  const setemail_dis = async (e, type) => {
    if (e.target.checked) {
      setEmailDisplay(1);
    } else {
      setEmailDisplay(0);
    }
  };

  const setmobile = async (e, type) => {
    if (e.target.checked) {
      setMobile(1);
    } else {
      setMobile(0);
    }
  };

  const setmobile_dis = async (e, type) => {
    if (e.target.checked) {
      setMobileDisplay(1);
    } else {
      setMobileDisplay(0);
    }
  };

  const setbday = async (e, type) => {
    if (e.target.checked) {
      setBirthday(1);
    } else {
      setBirthday(0);
    }
  };

  const setbday_dis = async (e, type) => {
    if (e.target.checked) {
      setBirthdayDisplay(1);
    } else {
      setBirthdayDisplay(0);
    }
  };

  const setbmon = async (e, type) => {
    if (e.target.checked) {
      setgender(1);
    } else {
      setgender(0);
    }
  };

  const setbmon_dis = async (e, type) => {
    if (e.target.checked) {
      setgenderDisplay(1);
    } else {
      setgenderDisplay(0);
    }
  };

  const settable = async (e, type) => {
    if (e.target.checked) {
      setTableNo(1);
    } else {
      setTableNo(0);
    }
  };

  const settable_dis = async (e, type) => {
    if (e.target.checked) {
      setTableNoDisplay(1);
    } else {
      setTableNoDisplay(0);
    }
  };
  const setcross = async (e, type) => {
    if (e.target.checked) {
      setCrossBtn(1);
    } else {
      setCrossBtn(0);
    }
  };

  const setcross_dis = async (e, type) => {
    if (e.target.checked) {
      setCrossBtnDisplay(1);
    } else {
      setCrossBtnDisplay(0);
    }
  };

  const setStatus = async (e, type) => {
    if (e.target.checked) {
      setPopupStatusDisplay(1);
    } else {
      setPopupStatusDisplay(0);
    }
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append(
      "name",
      '{"display": ' + name_dis + ',"mandatory": ' + name + "}"
    );
    formData.append(
      "email",
      '{"display": ' + email_dis + ',"mandatory": ' + email + "}"
    );
    formData.append(
      "mobile",
      '{"display": ' + mobile_dis + ',"mandatory": ' + mobile + "}"
    );
    formData.append(
      "birthday",
      '{"display": ' + birthday_dis + ',"mandatory": ' + birthday + "}"
    );
    formData.append(
      "gender",
      '{"display": ' + gender_dis + ',"mandatory": ' + gender + "}"
    );
    formData.append(
      "table_no",
      '{"display": ' + table_no_dis + ',"mandatory": ' + table_no + "}"
    );
    formData.append(
      "cross_btn",
      '{"display": ' + cross_btn_dis + ',"mandatory": ' + cross_btn + "}"
    );
    formData.append("status", status_dis);

    formData.append("id", id);
    formData.append("session", session);

    await axios.post(endpoints.updatePopup, formData).then((response) => {
      setloading(false);

      if (response.data.statusCode == 3) {
        window.location.reload(true);
      } else {
        alert("Please Try Again");
      }
    });
  };

  const removeImageHandler = async (id, type) => {
    await axios
      .post(endpoints.deleteImageRest, { id, type })
      .then((response) => {});
    window.location.reload();
  };

  return (
    <div className="ui main">
      <h2>Edit Popup Configuration</h2>
      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <div className="col col-4">
              <h5>Fields</h5>
            </div>
            <div className="col col-2">
              <h5>Mandatory</h5>
            </div>
            <div className="col col-2">
              <h5>Display</h5>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Name</lable>
            </div>
            <div className="col col-2 align-item-center">
              <input
                type="checkbox"
                checked={name === 1 ? true : false}
                onChange={(e) => setname(e)}
              />
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                checked={name_dis === 1 ? true : false}
                onChange={(e) => setname_dis(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Email</lable>
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="email"
                checked={email === 1 ? true : false}
                onChange={(e) => setemail(e)}
              />
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="email"
                checked={email_dis === 1 ? true : false}
                onChange={(e) => setemail_dis(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Mobile</lable>
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="mobile"
                checked={mobile === 1 ? true : false}
                onChange={(e) => setmobile(e)}
              />
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="mobile"
                checked={mobile_dis === 1 ? true : false}
                onChange={(e) => setmobile_dis(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>DOB</lable>
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="birthday"
                checked={birthday === 1 ? true : false}
                onChange={(e) => setbday(e)}
              />
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="birthday"
                checked={birthday_dis === 1 ? true : false}
                onChange={(e) => setbday_dis(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Gender</lable>
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="gender"
                checked={gender === 1 ? true : false}
                onChange={(e) => setbmon(e)}
              />
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="gender"
                checked={gender_dis === 1 ? true : false}
                onChange={(e) => setbmon_dis(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Table Number</lable>
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="table_no"
                checked={table_no === 1 ? true : false}
                onChange={(e) => settable(e)}
              />
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="table_no"
                checked={table_no_dis === 1 ? true : false}
                onChange={(e) => settable_dis(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Cross Button</lable>
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="cross_btn"
                checked={cross_btn === 1 ? true : false}
                onChange={(e) => setcross(e)}
              />
            </div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="cross_btn"
                checked={cross_btn_dis === 1 ? true : false}
                onChange={(e) => setcross_dis(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Status</lable>
            </div>
            <div className="col col-2"></div>
            <div className="col col-2">
              <input
                type="checkbox"
                name="status"
                checked={status_dis === "1" ? true : false}
                onChange={(e) => setStatus(e)}
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Session Time(in hour)</lable>
            </div>
            <div className="col col-3">
              <Input
                id="session"
                type="number"
                name="session"
                place="Session Time"
                onChange={(e) => onInputChange(e)}
                requiredInput="true"
                value={session}
                class="w-75"
              />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-4">
              <lable>Restaurant</lable>
            </div>
            <div className="col-md-3">{cat.rest}</div>
          </div>
          <hr />

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default PopupDetail;
